export default __webpack_public_path__ + "static/13_V1@2x-b1493d72f18460d8219487efcc78cd17.png";